var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1329_21326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 1.30078C21.8869 1.30078 24.7 4.1138 24.7 7.58398V18.417C24.7 21.8872 21.8869 24.7002 18.4167 24.7002H7.58374C4.11355 24.7002 1.30054 21.8872 1.30054 18.417V7.58398C1.30054 4.1138 4.11355 1.30078 7.58374 1.30078H18.4167Z",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6521 8.33789C11.6228 7.83422 12.7276 7.64924 13.8093 7.80957C14.9129 7.97322 15.9355 8.48747 16.7244 9.27637C17.5131 10.0652 18.0275 11.087 18.1912 12.1904C18.3516 13.2723 18.1666 14.3778 17.6628 15.3486C17.1591 16.3194 16.3615 17.1069 15.3845 17.5986C14.4076 18.0902 13.3002 18.2616 12.2205 18.0879C11.1408 17.9141 10.1432 17.4041 9.36987 16.6309C8.59648 15.8575 8.08661 14.8592 7.91284 13.7793C7.73916 12.6995 7.91041 11.5921 8.4021 10.6152C8.89385 9.63838 9.68135 8.84159 10.6521 8.33789Z",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 7.04199H18.9695",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1329_21326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1fb3827f2ad548bc6e71493844d9b92a.svg";
export { ForwardRef as ReactComponent };